<template>
  <div></div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
export default defineComponent({
});
</script>
